import React, { useState } from 'react';
import './LeaveManagement.css'
import { FaCheck, FaTimes, FaExclamationTriangle, FaStethoscope, FaClock } from 'react-icons/fa';
export const dummyLeaveRequests = [
  {
    id: '1',
    staffId: '1',
    type: 'planned',
    startDate: '2024-01-15',
    endDate: '2024-01-17',
    status: 'approved',
    reason: 'Vacation',
    submittedAt: '2024-01-01T10:00:00Z',
  },
  {
    id: '2',
    staffId: '2',
    type: 'sick',
    startDate: '2024-01-20',
    endDate: '2024-01-20',
    status: 'pending',
    reason: 'Flu symptoms',
    submittedAt: '2024-01-20T08:00:00Z',
  },
  {
    id: '3',
    staffId: '3',
    type: 'emergency',
    startDate: '2024-01-22',
    endDate: '2024-01-22',
    status: 'approved',
    reason: 'Family emergency',
    submittedAt: '2024-01-22T06:30:00Z',
  },
];

// Staff data matching the image
const staffMembers = [
  { id: '1', name: 'Sarah Johnson', initials: 'SJ' },
  { id: '2', name: 'Michael Chen', initials: 'MC' },
  { id: '3', name: 'Emma Rodriguez', initials: 'ER' },
];

const LeaveManagement = () => {
  const [leaveRequests, setLeaveRequests] = useState(dummyLeaveRequests);

  const handleApprove = (id) => {
    setLeaveRequests(prev =>
      prev.map(req => req.id === id ? { ...req, status: 'approved' } : req)
    );
  };

  const handleReject = (id) => {
    setLeaveRequests(prev =>
      prev.map(req => req.id === id ? { ...req, status: 'rejected' } : req)
    );
  };

  const getStaffMember = (staffId) => {
    return staffMembers.find(staff => staff.id === staffId);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatSubmittedAt = (dateStr) => {
    const date = new Date(dateStr);
    return `Submitted: ${date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    })} ${date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })}`;
  };

  const calculateDuration = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays === 1 ? '1 day' : `${diffDays} days`;
  };

  const pendingRequests = leaveRequests.filter(req => req.status === 'pending');
  const approvedRequests = leaveRequests.filter(req => req.status === 'approved');
  const rejectedRequests = leaveRequests.filter(req => req.status === 'rejected');

  return (
    <div className="lm-container">
      <div className="cards-staff">
        <div>
          <h2 className="cards-title">
            <FaClock style={{ color: "rgb(202 138 4)" }} className="icon" />
            Pending Requests ({pendingRequests.length})
          </h2>
        </div>
        {pendingRequests.map(request => {
          const staff = getStaffMember(request.staffId);
          const duration = calculateDuration(request.startDate, request.endDate);

          return (
            <div key={request.id} className="staff-card">
              <div className="staff-card-body">
                <div className="staff-avatar staff-avatar-color">{staff?.initials}</div>
                <div className="staff-details">
                  <div className="staff-name-row">{staff?.name}
                    <span className={`staff-count ${request.type}`}>{request.type}</span>
                    <span className={`staff-count ${request.status}`}>{request.status}</span>
                  </div>
                  <div className="lm-date-range">
                    {formatDate(request.startDate)} - {formatDate(request.endDate)}
                    <span className="lm-leave-type">({duration})</span>
                  </div>
                  <div className="lm-reason">{request.reason}</div>
                  <div className="lm-submitted">{formatSubmittedAt(request.submittedAt)}</div>
                  <div className="lm-action-buttons">
                    <button
                      className="lm-btn lm-btn-approve"
                      onClick={() => handleApprove(request.id)}
                    >
                      Approve
                    </button>
                    <button
                      className="lm-btn lm-btn-reject"
                      onClick={() => handleReject(request.id)}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="seperators"></div>

      {/* Approved Requests */}
      <div className="cards-staff">
        <div>
          <h2 className="cards-title">
            <FaCheck style={{ color: "#16a34a" }} className="icon" />
            Approved Requests ({approvedRequests.length})
          </h2>
        </div>
        {approvedRequests.map(request => {
          const staff = getStaffMember(request.staffId);
          const duration = calculateDuration(request.startDate, request.endDate);

          return (
            <div key={request.id} className="staff-card">
              <div className="staff-card-body">
                <div className="staff-avatar staff-avatar-color">{staff?.initials}</div>
                <div className="staff-details">
                  <div className="staff-name-row">{staff?.name}
                    <span className={`staff-count ${request.type}`}>{request.type}</span>
                    <span className={`staff-count ${request.status}`}>{request.status}</span>
                  </div>
                  <div className="lm-date-range">
                    {formatDate(request.startDate)} - {formatDate(request.endDate)}
                    <span className="lm-leave-type">({duration})</span>
                  </div>
                  <div className="lm-reason">{request.reason}</div>
                  <div className="lm-submitted">{formatSubmittedAt(request.submittedAt)}</div>
                </div>
              </div>


            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeaveManagement;